var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title_box_main"},[_c('div',{staticClass:"cionsv"}),_c('div',{staticClass:"titles-label"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }